import { Injectable } from '@angular/core';
import { Store } from '@examdojo/state';
import { createStore, withProps } from '@ngneat/elf';
import { CurrencyStoreState, createInitialCurrencyState } from './currency.model';

@Injectable({ providedIn: 'root' })
export class CurrencyStore extends Store<CurrencyStoreState> {
  constructor() {
    const store = createStore({ name: 'currency' }, withProps<CurrencyStoreState>(createInitialCurrencyState()));
    super(store);
  }
}
